import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";
import { serializeRouteForStore } from "../../utils/routeState";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) =>
    serializeRouteForStore(action.payload) ?? state,
  {},
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers('USER');

export const users = userReducers.list;
export const usersForm = userReducers.form;

const customerReducers = createCrudReducers('CUSTOMER');

export const customers = customerReducers.list;
export const customersForm = customerReducers.form;
const visitReducers = createCrudReducers('VISIT');

export const visits = visitReducers.list;
export const visitsForm = visitReducers.form;
const OfferReducers = createCrudReducers('OFFER');

export const Offers = OfferReducers.list;
export const OffersForm = OfferReducers.form;
const templateReducers = createCrudReducers('TEMPLATE');

export const templates = templateReducers.list;
export const templatesForm = templateReducers.form;
const emailuserReducers = createCrudReducers('EMAILUSER');

export const emailusers = emailuserReducers.list;
export const emailusersForm = emailuserReducers.form;
const productReducers = createCrudReducers('PRODUCT');

export const products = productReducers.list;
export const productsForm = productReducers.form;
const historicReducers = createCrudReducers('HISTORIC');

export const historics = historicReducers.list;
export const historicsForm = historicReducers.form;
const noteReducers = createCrudReducers('NOTE');

export const notes = noteReducers.list;
export const notesForm = noteReducers.form;
